import React, { useState, useRef, useEffect, useCallback } from "react";
import cycleBg from "../Img/cycle1.png";
import cycleDetailImage from "../Img/cycle-detail-image.png";
import contactFormBg from "../Img/contact-form-bg.png";
import scoop01 from "../Img/scoop/01.png";
import scoop02 from "../Img/scoop/02.png";
import scoop03 from "../Img/scoop/03.png";
import scoop04 from "../Img/scoop/04.png";
import scoop05 from "../Img/scoop/05.png";
import scoop06 from "../Img/scoop/06.png";
import scoop07 from "../Img/scoop/07.png";
import scoop08 from "../Img/scoop/08.png";
import scoop09 from "../Img/scoop/09.png";
import brand1 from "../Img/brand/brand1.png";
import brand2 from "../Img/brand/brand2.png";
import brand3 from "../Img/brand/brand3.png";
import brand4 from "../Img/brand/brand4.png";
import brand5 from "../Img/brand/brand5.png";
import brand6 from "../Img/brand/brand6.png";
import brand7 from "../Img/brand/brand7.jpeg";
import brand8 from "../Img/brand/brand8.jpeg";
import brand9 from "../Img/brand/brand9.jpeg";
import brand10 from "../Img/brand/brand10.jpeg";
import person1 from "../Img/person1.jpg";
import person2 from "../Img/person2.jpg";
import person3 from "../Img/person3.jpg";
import person4 from "../Img/person4.jpg";
import {
  Bike,
  Package,
  Wind,
  RefreshCw,
  Bell,
  Shield,
  Video,
  Wrench,
  Repeat,
  PhoneCall,
  Star,
  Crown,
  Heart,
  Sparkles,
  Quote,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ArrowRight,
  Phone,
  Mail,
  User,
  Smartphone,
  MessageCircle,
  CheckCircle,
  Droplets,
  Brush,
  Cog,
  Bike as BikeIcon,
  Sparkles as SparklesIcon,
} from "lucide-react";
import "../CSS/Global.css";
import "../CSS/CycleService.css";
import { sendToWhatsApp } from "./utils/Whatsapp";
import { Link } from "react-router-dom";

const CycleService = ({
  cartItemsLength,
  setCartItemLength,
  fetchCart,
  cartButtons,
}) => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [activePackage, setActivePackage] = useState("non-gear");
  const [expanded, setExpanded] = useState({});
  const brandsMarqueeRef = useRef(null);
  const isBrandsAutoPausedRef = useRef(false);
  const brandsPauseTimerRef = useRef(null);
  const BRANDS_REPEAT_COUNT = 4;
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    inquiry: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New request Form Submission from Cycle Service page:\n\n*Name:* ${formData.name}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Inquiry:* ${formData.inquiry}`;
    sendToWhatsApp(message);
    setFormData({ name: "", phone: "", email: "", inquiry: "" });
  };

  // Create an array of images
  const scoopImages = [
    scoop01,
    scoop02,
    scoop03,
    scoop04,
    scoop05,
    scoop06,
    scoop07,
    scoop08,
    scoop09,
  ];

  const services = {
    "non-gear": [
      {
        name: "STANDARD",
        desc: "Essential tune-up for non-gear cycles. Keeps your brakes sharp, chain smooth, and ride effortless every day",
        price: 599,
        includes: [
          "• General Tune Up",
          "• Hubs Checking & Headset Alignment",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables",
          "• Soap Washing & Squeaky Clean Wiping",
          "• Correct Tire Inflation",
        ],
        duration: "4 Hours",
        Doorstep: " Available",
        amcPrice:" 1499",
      },
      {
        name: "PREMIUM",
        desc: "Deep clean and full grease service with detailed inspection. Restores your cycle’s effortless, like-new glide",
        price: 1200,
        includes: [
          "• Gear Tune Up",
          "• Dismantle, Grease & Re-install Hubs, Bottom Bracket & Headset",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables (inner/outer)",
          "•  Soap Washing & Squeaky Clean Wiping",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Front & Rear Brake Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
        ],
        duration: "8 Hours",
        Doorstep: " Available",
        amcPrice:" 2999",
      },
    ],
    gear: [
      {
        name: "STANDARD",
        desc: "Regular care for geared cycles. Keeps gear shifting crisp, braking precise, and performance consistent",
        price: 999,
        includes: [
          "• Gear Tune Up",
          "• Hubs Checking & Headset Alignment",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
        ],
        duration: "5 hours",
        Doorstep: " Available",
        amcPrice:" 2499",
      },
      {
        name: "PREMIUM",
        desc: " Deep-clean overhaul with full gear tuning and greasing. Brings back that smooth, like-new ride feel ",
        price: 1499,
        includes: [
          "• Gear Tune Up",
          "• Front & Rear Brake Adjustment",
          "• Correct Tire Inflation",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
        ],
        duration: "8 hours",
        Doorstep: " Available",
        amcPrice:" 3500",
      },
      {
        name: "PRO",
        desc: " Complete precision service with drivetrain detailing, anti-rust protection, and expert tuning for peak performance ",
        price: 1999,
        includes: [
          "• Gear Tune Up",
          "• Front & Rear Brake Adjustment",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
          "• Advanced Component Cleaning",
          "• High-end Lubrication",
          "• Extended Warranty",
          "• Anti-Rust Treatment",
        ],
        duration: "12 hours",
        Doorstep: " Available",
        amcPrice:" 4500",
      },
    ],
    Professional: [
      {
        name: "Professional Muc off",
        desc: "Every part is taken care of with Muc off lubricants to ensure optimal performance ,longer component life. ",
        price: 2999,
        includes: [
          "• Gear Tune Up",
          "• Dismantle, Grease & Re-install Hubs, Bottom Bracket & Headset",
          "• Front & Rear Brake Adjustment",
          "• Lube Chain & Cables (inner/outer)",
          "• Soap Washing & Squeaky Clean Wiping",
          "• Front & Rear Derailleur Adjustment",
          "• Bottom Bracket Adjustment",
          "• Wheel True & Tension",
          "• Dismantle & clean Drivetrain",
          "• Advanced Component Cleaning",
          "• High-end Lubrication",
          "• Extended Warranty",
          "• Anti-Rust Treatment",
        ],
        duration: "12 Hours",
        Doorstep: " Available",
        amcPrice:" 4500",
      },
    ],
  };

  const addOnServices = [
    "Custom Wrapping & Restoration",
    "Ceramic Coating & Polish",
    "Suspension Overhaul",
    "Hydraulic Brake Bleeding",
    "Cycle Assembly",
    "Dismantling & Packaging",
  ];

  const testimonials = [
    {
      name: "Vishal Desai",
      rating: 5,
      text: "I rented a bicycle from Cycle Rental Service last month and it was in excellent condition. The whole rental process was quick and very simple. Riding the cycle was a great experience and I will definitely rent again in the future. I highly recommend Cycle Rental Service to anyone looking for a reliable cycle rental.",
      image: person1,
    },
    {
      name: "Shraddha Aryaa",
      rating: 5,
      text: "Renting a cycle from Cycle Rental Service was a wonderful experience for me. After my second baby, I wanted to get back into a healthy routine and cycling helped a lot. The bicycles were comfortable and the team was extremely supportive. I truly appreciate their service and wish them continued success.",
      image: person2,
    },
    {
      name: "Alisha Pereira",
      rating: 5,
      text: "My experience with Cycle Rental Service was very smooth from the first enquiry to the delivery and pickup of the bicycle. I wanted to relearn cycling after many years and their team was very helpful. They even suggested the right cycle based on my height, which made the ride comfortable and enjoyable.",
      image: person3,
    },
    {
      name: "Binnita Shah",
      rating: 5,
      text: "I was searching online to rent cycles for myself and my brother when I found Cycle Rental Service. The team was very friendly and helped us even on short notice during a Sunday. They took the time to understand our plans and recommended the best cycles for us. It was a great experience overall.",
      image: person4,
    },
  ];

  const brandLogos = [
    { src: brand1, alt: "BTWIN" },
    { src: brand7, alt: "PARKTOOL" },
    { src: brand3, alt: "GIANT" },
    { src: brand4, alt: "SCOTT" },
    { src: brand5, alt: "TREK" },
    { src: brand8, alt: "ICETOOLZ" },
    { src: brand9, alt: "MERIDA" },
    { src: brand10, alt: "POLYGON" },
  ];

  const toggleExpanded = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={16}
        className={index < rating ? "star-filled" : "star-empty"}
        fill={index < rating ? "currentColor" : "none"}
      />
    ));
  };

  const nextSlide = () => {
    if (startIndex + 3 < testimonials.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prevSlide = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const scrollToServicePlans = () => {
    const section = document.getElementById("service-plans");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollBrands = (direction) => {
    if (!brandsMarqueeRef.current) return;

    const marquee = brandsMarqueeRef.current;
    const brandsGrid = marquee.querySelector(".brands-grid");
    const firstBrand = marquee.querySelector(".brand-item");

    let scrollAmount = 220;
    if (firstBrand && brandsGrid) {
      const brandWidth = firstBrand.getBoundingClientRect().width;
      const gap = parseFloat(window.getComputedStyle(brandsGrid).gap || "0");
      scrollAmount = brandWidth + gap;
    }

    const singleSetScrollWidth = marquee.scrollWidth / BRANDS_REPEAT_COUNT;
    if (
      direction === "right" &&
      marquee.scrollLeft >= singleSetScrollWidth - 2
    ) {
      marquee.scrollLeft -= singleSetScrollWidth;
    } else if (direction === "left" && marquee.scrollLeft <= 2) {
      marquee.scrollLeft += singleSetScrollWidth;
    }

    isBrandsAutoPausedRef.current = true;
    if (brandsPauseTimerRef.current) {
      clearTimeout(brandsPauseTimerRef.current);
    }
    brandsPauseTimerRef.current = setTimeout(() => {
      isBrandsAutoPausedRef.current = false;
    }, 900);

    brandsMarqueeRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const marquee = brandsMarqueeRef.current;
    if (!marquee) return;

    let isHovered = false;
    const autoScroll = setInterval(() => {
      if (isHovered || isBrandsAutoPausedRef.current) return;
      marquee.scrollLeft += 1;
      const singleSetScrollWidth = marquee.scrollWidth / BRANDS_REPEAT_COUNT;
      if (marquee.scrollLeft >= singleSetScrollWidth) {
        marquee.scrollLeft -= singleSetScrollWidth;
      }
    }, 20);

    const pause = () => {
      isHovered = true;
    };
    const resume = () => {
      isHovered = false;
    };

    marquee.addEventListener("mouseenter", pause);
    marquee.addEventListener("mouseleave", resume);

    return () => {
      clearInterval(autoScroll);
      if (brandsPauseTimerRef.current) {
        clearTimeout(brandsPauseTimerRef.current);
      }
      marquee.removeEventListener("mouseenter", pause);
      marquee.removeEventListener("mouseleave", resume);
    };
  }, []);

  return (
    <div className="min-h-screen">
      {/* Brands We Deal In Section */}
      

      <section className="bike-service-hero">
        <div className="bike-service-bg-spot spot-1"></div>
        <div className="bike-service-bg-spot spot-2"></div>
        <div className="container">
          {/* Main Hero Content */}
          <div className="bike-service-hero-content">
            <h1 className="bike-service-title">
              <span>Professional Bicycle Service & Repair</span>
            </h1>
            <Link
              to="#service-plans"
              className="bike-service-cta-btn"
              onClick={(e) => {
                e.preventDefault();
                scrollToServicePlans();
              }}
            >
              Get Started
            </Link>
          </div>
        </div>
      </section>
      <section className="brands-section">
        <div className="container">
          <h2 className="section-title">
            <span className="brands-title">Brands We Work With</span>
          </h2>

          <div className="brands-slider-wrapper">
            <button
              type="button"
              className="brands-nav-btn brands-nav-btn-left"
              onClick={() => scrollBrands("left")}
              aria-label="Scroll brands left"
            >
              <ChevronLeft size={20} />
            </button>

            <div className="brands-marquee" ref={brandsMarqueeRef}>
              <div className="brands-grid">
                {Array.from({ length: BRANDS_REPEAT_COUNT }, (_, repeatIndex) =>
                  brandLogos.map((logo, logoIndex) => (
                    <img
                      key={`${logo.alt}-${repeatIndex}-${logoIndex}`}
                      src={logo.src}
                      alt={logo.alt}
                      className="brand-item"
                    />
                  )),
                )}
              </div>
            </div>

            <button
              type="button"
              className="brands-nav-btn brands-nav-btn-right"
              onClick={() => scrollBrands("right")}
              aria-label="Scroll brands right"
            >
              <ChevronRight size={20} />
            </button>
          </div>

          <p className="brands-more">...and a lot more.</p>
        </div>
      </section>

      {/* Cycle Service Packages */}
      <section id="service-plans" className="packages-section">
        <div className="container">
          <h2 className="section-title packages-title">
            Bicycle Service Plans
          </h2>
          <div className="packages-tabs">
            <button
              className={`packages-tab ${activePackage === "non-gear" ? "active" : ""}`}
              onClick={() => setActivePackage("non-gear")}
            >
              Non Gear
            </button>
            <button
              className={`packages-tab ${activePackage === "gear" ? "active" : ""}`}
              onClick={() => setActivePackage("gear")}
            >
              Gear
            </button>
            <button
              className={`packages-tab ${activePackage === "Professional" ? "active" : ""}`}
              onClick={() => setActivePackage("Professional")}
            >
              Professional
            </button>
          </div>
          <div className="packages-cards">
            {services[activePackage].map((service, index) => (
              <div key={`${activePackage}-${index}`} className="service-card">
                <div className="service-header">
                  <h3>{service.name}</h3>
                  <button
                    className="expand-btn"
                    onClick={() => toggleExpanded(`${activePackage}-${index}`)}
                  >
                    {expanded[`${activePackage}-${index}`] ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </button>
                </div>
                <p>{service.desc}</p>
                
                {/* --- COLLAPSIBLE SECTION --- */}
                <div className={`service-details-wrapper ${expanded[`${activePackage}-${index}`] ? "open" : ""}`}>
                  <div className="service-details">
                    <div className="detail-row">
                      <span>Includes:</span>
                      <div className="includes-list">
                        {service.includes.map((item, i) => (
                          <div key={i} className="include-item">
                            <CheckCircle
                              size={16}
                              className="include-icon-small mr-2"
                            />
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="detail-row">
                      <span>Duration:</span>
                      <span>{service.duration}</span>
                    </div>
                    <div className="detail-row">
                      <span>Place of Service:</span>
                      <span>Our Workshop</span>
                    </div>
                    <div className="detail-row">
                      <span>Doorstep Pickup & Drop</span>
                      <span>{service.Doorstep}</span>
                    </div>

                    {/* AMC Button and OR divider hidden inside */}
                    <div className="service-booking-actions">
                      <button
                        className="book-btn-outline"
                        onClick={() => {
                          const serviceType =
                            activePackage.charAt(0).toUpperCase() +
                            activePackage.slice(1) +
                            " Cycle";
                          const amcPrice =
                            service.amcPrice || (service.price * 2.5).toFixed(0);
                          const msg = `*AMC Service Booking Request*\n\nService Type: ${serviceType} - ${service.name} AMC\nPrice: ₹${amcPrice}\n\nPlease confirm AMC booking details.`;
                          sendToWhatsApp(msg);
                        }}
                      >
                        {service.name} AMC (Yearly) for ₹
                        {service.amcPrice || (service.price * 2.5).toFixed(0)}
                      </button>

                      <p className="amc-includes-text">
                        (Includes 2 {service.name} Services)
                      </p>

                      <div className="or-divider">OR</div>
                    </div>
                  </div>
                </div>
                {/* --- END COLLAPSIBLE SECTION --- */}

                {/* --- ALWAYS VISIBLE BUTTON --- */}
                <div style={{ marginTop: '20px', width: '100%' }}>
                  <button
                    className="book-btn-filled"
                    onClick={() => {
                      const serviceType =
                        activePackage.charAt(0).toUpperCase() +
                        activePackage.slice(1) +
                        " Cycle";
                      const msg = ` *Cycle Service Booking Request*\n\n Service Type: ${serviceType} - ${service.name}\n Price: ₹${service.price}\n Duration: ${service.duration}\n Doorstep: ${service.Doorstep}\n\nPlease confirm booking details.`;
                      sendToWhatsApp(msg);
                    }}
                  >
                    Book Now for ₹{service.price}
                  </button>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="addon-services-section">
        <div className="container">
          <h2 className="section-title">Additional Services</h2>

          <div className="addon-services-grid">
            {addOnServices.map((category, index) => (
              <div className="addon-service-card" key={index}>
                <h3 className="addon-service-category">{category}</h3>
                <div className="addon-service-footer">
                  <button
                    type="button"
                    className="addon-book-now-btn"
                    onClick={() => {
                      const msg = `Add-on Service Booking\n\nCategory: ${category}\n\nReady to book? Share your details!`;
                      sendToWhatsApp(msg);
                    }}
                  >
                    Get Quote
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Cycle Service Process Section */}
      <section className="service-process-section">
        <div className="service-process-bg-spot spot-center"></div>
        <div className="container">
          <h2 className="section-title">
            <span className="black-text">Our Cycle Care Process</span>{" "}
            <span className="blue-text">~ Built around your needs</span>
          </h2>

          <div className="service-process-list">
            {/* Step 1 */}
            <div className="service-process-item">
              <div className="service-process-number">1</div>
              <div className="service-process-content">
                <h3>Doorstep Pickup</h3>
                <p>
                  We collect your bicycle from your location and safely
                  transport it to our service center.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="service-process-item">
              <div className="service-process-number">2</div>
              <div className="service-process-content">
                <h3>Initial Inspection Photos</h3>
                <p>
                  Before starting, we share images of your cycle’s current
                  condition so you stay fully informed.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="service-process-item">
              <div className="service-process-number">3</div>
              <div className="service-process-content">
                <h3>Detailed Breakdown Check</h3>
                <p>
                  Your cycle is carefully inspected and dismantled where needed,
                  with updates shared for complete transparency.
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div className="service-process-item">
              <div className="service-process-number">4</div>
              <div className="service-process-content">
                <h3>Service & Cost Estimate</h3>
                <p>
                  We provide a clear summary of required work along with an
                  estimated cost before proceeding.
                </p>
              </div>
            </div>

            {/* Step 5 */}
            <div className="service-process-item">
              <div className="service-process-number">5</div>
              <div className="service-process-content">
                <h3>After-Service Updates</h3>
                <p>
                  Once servicing is complete, we share updated photos showing
                  the improvements made.
                </p>
              </div>
            </div>

            {/* Step 6 */}
            <div className="service-process-item">
              <div className="service-process-number">6</div>
              <div className="service-process-content">
                <h3>Easy Billing</h3>
                <p>
                  A detailed invoice is sent for quick and hassle-free payment.
                </p>
              </div>
            </div>

            {/* Step 7 */}
            <div className="service-process-item">
              <div className="service-process-number">7</div>
              <div className="service-process-content">
                <h3>Delivery to Your Door</h3>
                <p>
                  Your serviced cycle is delivered back to you, fully ready for
                  a smooth and enjoyable ride.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Inside Scoop Section */}
      <section className="inside-scoop-section">
        <div className="container">
          <h2 className="section-title">Inside The Journey</h2>

          <div className="rowgallery">
            {/* Column 1 */}
            <div className="columngallery">
              <img
                src={scoop01}
                alt="Inside Scoop 1"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop05}
                alt="Inside Scoop 5"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop09}
                alt="Inside Scoop 9"
                style={{ width: "100%", marginBottom: "6px" }}
              />
            </div>

            {/* Column 2 */}
            <div className="columngallery">
              <img
                src={scoop02}
                alt="Inside Scoop 2"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop06}
                alt="Inside Scoop 6"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              
            </div>

            {/* Column 3 */}
            <div className="columngallery">
              <img
                src={scoop03}
                alt="Inside Scoop 3"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop07}
                alt="Inside Scoop 7"
                style={{ width: "100%", marginBottom: "6px" }}
              />
             
            </div>

            {/* Column 4 */}
            <div className="columngallery">
              <img
                src={scoop04}
                alt="Inside Scoop 4"
                style={{ width: "100%", marginBottom: "6px" }}
              />
              <img
                src={scoop08}
                alt="Inside Scoop 8"
                style={{ width: "100%", marginBottom: "6px" }}
              />
             
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-carousel-section">
        <div className="container">
          <h2 className="section-title">What Our Riders Say</h2>

          <div className="testimonials-carousel-container">
            <button
              className={`carousel-arrow carousel-arrow-left ${startIndex === 0 ? "disabled" : ""}`}
              onClick={prevSlide}
              disabled={startIndex === 0}
            >
              <ChevronLeft size={24} />
            </button>

            <div className="testimonials-carousel-track">
              {testimonials
                .slice(startIndex, startIndex + 3)
                .map((testimonial, index) => (
                  <div
                    key={startIndex + index}
                    className="testimonial-carousel-card"
                  >
                    <div className="testimonial-header">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="testimonial-image"
                      />
                      <div className="testimonial-info">
                        <h4>{testimonial.name}</h4>
                        <div className="testimonial-rating">
                          {renderStars(testimonial.rating)}
                        </div>
                      </div>
                    </div>

                    <div className="testimonial-content">
                      <p>"{testimonial.text}"</p>
                    </div>
                  </div>
                ))}
            </div>

            <button
              className={`carousel-arrow carousel-arrow-right ${startIndex + 3 >= testimonials.length ? "disabled" : ""}`}
              onClick={nextSlide}
              disabled={startIndex + 3 >= testimonials.length}
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div className="carousel-dots">
            {Array.from({ length: Math.ceil(testimonials.length - 2) }).map(
              (_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === startIndex ? "active" : ""}`}
                  onClick={() => setStartIndex(index)}
                />
              ),
            )}
          </div>
        </div>
      </section>

      <section className="cta-section-two-same">
        <div className="container">
          <h2 className="section-title-two-same">
            We provide technicians for long rides and tours
          </h2>
          <Link
            to="https://wa.me/918082080816"
            className="cta-button-two-same"
            target="_blank"
          >
            Hire Now
          </Link>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">
            <span className="black-text">Frequently Asked</span>{" "}
            <span className="blue-text">Questions</span>
          </h2>

          <div className="faq-grid">
            {/* FAQ Item 1 */}
            <div className={`faq-item ${activeFaq === 0 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(0)}>
                <h3>How long does cycle service take?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 0 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Basic service takes 45 mins to 1 hour, while complete overhaul
                  may take 2-3 hours depending on the service package you
                  choose.
                </p>
              </div>
            </div>

            {/* FAQ Item 2 */}
            <div className={`faq-item ${activeFaq === 1 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(1)}>
                <h3>Do you provide doorstep pickup and delivery?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 1 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we offer free doorstep pickup and delivery for all our
                  service packages within Mumbai.
                </p>
              </div>
            </div>

            {/* FAQ Item 3 */}
            <div className={`faq-item ${activeFaq === 2 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(2)}>
                <h3>What is the warranty on your service?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 2 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  We provide 7 days warranty on all our services. If you face
                  any issue within 7 days, we'll fix it free of cost.
                </p>
              </div>
            </div>

            {/* FAQ Item 4 */}
            <div className={`faq-item ${activeFaq === 3 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(3)}>
                <h3>Do I need to book an appointment?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 3 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we recommend booking an appointment to ensure smooth
                  service. You can book directly through our website.
                </p>
              </div>
            </div>

            {/* FAQ Item 5 */}
            <div className={`faq-item ${activeFaq === 4 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(4)}>
                <h3>What payment methods do you accept?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 4 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  We accept all major payment methods including UPI,
                  Credit/Debit cards, Net Banking, and Cash on delivery.
                </p>
              </div>
            </div>

            {/* FAQ Item 6 */}
            <div className={`faq-item ${activeFaq === 5 ? "active" : ""}`}>
              <div className="faq-question" onClick={() => toggleFaq(5)}>
                <h3>Do you use genuine parts for replacement?</h3>
                <ChevronDown
                  className={`faq-icon ${activeFaq === 5 ? "rotated" : ""}`}
                  size={20}
                />
              </div>
              <div className="faq-answer">
                <p>
                  Yes, we use 100% genuine parts for all replacements. You can
                  also request specific brands if needed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="help-section">
        <div className="help-overlay"></div>
        <div className="container">
          <div className="help-content">
            <h2 className="help-title"> Have Questions? </h2>

            <div className="help-contact">
              <div className="help-contact-item">
                <Phone size={20} />
                <a href="tel:+918082080816">+91 8082080816</a>
              </div>
              <div className="help-contact-item">
                <Mail size={20} />
                <a href="mailto:info@cyclerentalservices.com">info@cyclerentalservices.com</a>
              </div>
            </div>

            <form className="help-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <User size={18} className="form-icon" />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={formData.name}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <Smartphone size={18} className="form-icon" />
                <input
                  type="tel"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <Mail size={18} className="form-icon" />
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <MessageCircle size={18} className="form-icon" />
                <input
                  type="text"
                  placeholder="What are you looking for?"
                  value={formData.inquiry}
                  onChange={(e) =>
                    setFormData({ ...formData, inquiry: e.target.value })
                  }
                />
              </div>

              <button type="submit" className="help-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CycleService;
